<script>
import { h, defineAsyncComponent } from 'vue'
import LoadingIndicator from './LoadingIndicator.vue'
import Poll from './Poll.vue'
const VideoPlayer = defineAsyncComponent(() => import('./VideoPlayer.vue'));
import UpVote from './UpVote.vue'
import CommentsModal from './CommentsModal.vue'
import CommentsLoader from './CommentsLoader.vue'
import ArticleShare from './ArticleShare.vue'
import AsyncRender from './AsyncRender.vue'
import DownloadIcon from './DownloadIcon.vue'
import ImageSwiper from './ImageSwiper.vue'
import LazyImage from './LazyImage.vue'
import SocialShare from './SocialShare.vue'
const TranscoderProgress = defineAsyncComponent(() => import('./TranscoderProgress.vue'));

export default {
	props: {
		content: {
			type: String,
			default: '',
		},
		deviceContext: {
			type: Object,
			default: () => ({
				app: false,
				mobile: false,
				desktop: true,
			}),
		},
	},
	render() {
		const parent = this;
		const r = {
			components: {
				LoadingIndicator,
				Poll,
				VideoPlayer,
				UpVote,
				CommentsModal,
				CommentsLoader,
				ArticleShare,
				AsyncRender,
				DownloadIcon,
				ImageSwiper,
				LazyImage,
				SocialShare,
				TranscoderProgress,
			},
			// Only trusted Twig markup: member-supplied text must be escaped and inside v-pre.
			template: `<div class="content">${this.content || ''}</div>`,
			data() {
				return {
					device: parent.deviceContext,
				};
			},
			methods: {
				hello() {
					
				},
			},
		};
		return h(r);
	},
};
</script>
